import React, { useState, useEffect, useCallback } from 'react';
// import { useTranslation } from "react-i18next";
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";

import "./index.scss";

import SkeletonLoader from "../../../../components/ui/SkeletonLoader";

import Findings from "./Findings";
import BrandInsights from "./BrandInsights";
import OrganizationHacker from "./OrganizationHacker";
import TopVulnerabilities from "./TopVulnerabilities";
import TopSubDomains from './TopSubDomains';
import MapChart from './MapChart';
import BubbleChart from './BubbleChart';
import DomainHackerScore from './DomainHackerScore';
import DomainRiskScore from "./DomainRiskScore";
import BusinessEmail from './BusinessEmail';

import { formatNumber } from "../../../../utils/util";

import { useScanInfoContext } from "../../../ScanInfo/ScanInfoContext";

import { useSelector, useDispatch } from 'react-redux';
import { getDigitalAsset, getDigitalFootPrint } from "../../../../store/actions/dashboardAction";

const Dashboard = () => {

    const digitalAssetResponse = useSelector((state) => state.dashboard.digitalAssets);
    const digitalFootPrintResponse = useSelector((state) => state.dashboard.digitalFootPrint);

    const dispatch = useDispatch();

    const {
        domainId,
        scanId,
        organizationId,
        triggerStatsFetch,
        setTriggerStatsFetch,
    } = useScanInfoContext();

    const [isDigitalAssetLoading, setIsDigitalAssetLoading] = useState(false);
    const [isDigitalFootPrintLoading, setIsDigitalFootPrintLoading] = useState(false);
    const [totalDigitalFootPrint, setTotalDigitalFootPrint] = useState(0);
    const [totalDigitalAsset, setTotalDigitalAsset] = useState(0);
    

    const fetchDigitalAssets = useCallback(()=>{
        setIsDigitalAssetLoading(true)
        setIsDigitalFootPrintLoading(true)
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        dispatch(getDigitalAsset(params))
        dispatch(getDigitalFootPrint(params))
    },[organizationId, domainId, scanId, dispatch])

    useEffect(() => {            
        if (triggerStatsFetch) {
            fetchDigitalAssets()
            setTriggerStatsFetch(false);
        }
    }, [triggerStatsFetch, setTriggerStatsFetch, fetchDigitalAssets]);

    useEffect(()=>{
        if(digitalAssetResponse !== null) {
            if(digitalAssetResponse?.status !== "failed") {
                let total = digitalAssetResponse?.stats?.digital_asset?.subdomain + digitalAssetResponse?.stats?.digital_asset?.ip_address
                setTotalDigitalAsset(total)
            } else {
                setTotalDigitalAsset(0)
            }
            setIsDigitalAssetLoading(false)
        }
    },[digitalAssetResponse])

    useEffect(()=>{
        if(digitalFootPrintResponse !== null) {
            if(digitalFootPrintResponse?.status !== "failed" && digitalFootPrintResponse !== "Not Found" && digitalFootPrintResponse?.stats?.digital_footprint) {
                let { associated_domain, dns_record, 
                    gitleak, hosting_provider, 
                    mobile_application, open_port, 
                    ssl_certificate, technology, 
                    webserver} = digitalFootPrintResponse?.stats?.digital_footprint
                let total = associated_domain + dns_record + gitleak + hosting_provider + mobile_application + open_port + ssl_certificate + technology + webserver;
                setTotalDigitalFootPrint(formatNumber(total))
            }  else {
                setTotalDigitalFootPrint(0)
            }
            setIsDigitalFootPrintLoading(false)          
        }
    },[digitalFootPrintResponse])

    // const [selectedCategory, setSelectedCategory] = useState('Application Vulnerability');

    // const categories = [
    //     { name: 'Application Vulnerability', percent: '-29%', hasWarning: true },
    //     { name: 'DNS Security', percent: '-20%', hasWarning: true },
    //     { name: 'Data Breach & Leak Intelligence', percent: '-28%', hasWarning: true },
    //     { name: 'IP Reputation', percent: '-7%', hasWarning: false },
    //     { name: 'Sensitive File & Data Exposures', percent: '-11%', hasWarning: false },
    //     { name: 'Code Exposures', percent: '-6%', hasWarning: false },
    //     { name: 'Email Security Misconfiguration', percent: '-8%', hasWarning: false },
    //     { name: 'Infrastructure Configuration Risk', percent: '-14%', hasWarning: false },
    //     { name: 'Network Threat', percent: '-5%', hasWarning: false },
    // ];

    // const vulnerabilitiesData = {
    //     'Application Vulnerability': [
    //         { id: 'cves', title: 'CVEs', subtitle: "'Known softwares detected'", percent: '-15%', items: [{ count: 10, label: 'Version Based CVEs', type: 'teal' }, { count: 20, label: 'POC Verified CVEs', type: 'cyan' }], actions: [{ label: 'Patch known exploits', priority: 'quick', improvement: '03%' }, { label: 'Patch outdated versions', priority: 'high', improvement: '12%' }] },
    //         { id: 'cnvds', title: 'CNVDs', subtitle: "'China DB Vulnerabilities'", percent: '-9%', items: [{ count: 10, label: 'Critical Severity Vulns', type: 'teal' }, { count: 20, label: 'High Severity Vulns', type: 'cyan' }], actions: [{ label: 'Apply Vendor Fixes', priority: 'quick', improvement: '03%' }, { label: 'Apply Track Advisories', priority: 'high', improvement: '06%' }] },
    //         { id: 'other', title: 'Other Vulnerabilities', subtitle: "'Logic flaws, old libs'", percent: '-5%', items: [{ count: 10, label: 'Critical Severity Vulns', type: 'teal' }, { count: 20, label: 'High Severity Vulns', type: 'cyan' }], actions: [{ label: 'Apply Vendor Fixes', priority: 'quick', improvement: '02%' }, { label: 'Apply Track Advisories', priority: 'high', improvement: '03%' }] }
    //     ],
    //     'DNS Security': [
    //         { id: 'dnssec', title: 'DNSSEC', subtitle: "'DNS Security Extensions'", percent: '-12%', items: [{ count: 5, label: 'Missing DNSSEC', type: 'teal' }, { count: 8, label: 'Invalid Signatures', type: 'cyan' }], actions: [{ label: 'Enable DNSSEC', priority: 'high', improvement: '08%' }, { label: 'Fix DNS records', priority: 'quick', improvement: '04%' }] },
    //         { id: 'dns-misconfig', title: 'DNS Misconfig', subtitle: "'Zone transfer issues'", percent: '-8%', items: [{ count: 3, label: 'Open Zone Transfers', type: 'teal' }, { count: 12, label: 'Dangling Records', type: 'cyan' }], actions: [{ label: 'Restrict zone transfers', priority: 'high', improvement: '05%' }, { label: 'Remove stale records', priority: 'quick', improvement: '03%' }] }
    //     ],
    //     'Data Breach & Leak Intelligence': [
    //         { id: 'credentials', title: 'Leaked Credentials', subtitle: "'Exposed passwords'", percent: '-18%', items: [{ count: 45, label: 'Compromised Accounts', type: 'teal' }, { count: 12, label: 'Admin Credentials', type: 'cyan' }], actions: [{ label: 'Force password reset', priority: 'high', improvement: '10%' }, { label: 'Enable MFA', priority: 'high', improvement: '08%' }] },
    //         { id: 'pii', title: 'PII Exposure', subtitle: "'Personal data leaks'", percent: '-10%', items: [{ count: 8, label: 'Customer Records', type: 'teal' }, { count: 3, label: 'Employee Data', type: 'cyan' }], actions: [{ label: 'Data encryption', priority: 'high', improvement: '06%' }, { label: 'Access controls', priority: 'quick', improvement: '04%' }] }
    //     ],
    //     'IP Reputation': [
    //         { id: 'blacklist', title: 'Blacklisted IPs', subtitle: "'Reputation issues'", percent: '-7%', items: [{ count: 2, label: 'Spam Blacklists', type: 'teal' }, { count: 1, label: 'Malware Lists', type: 'cyan' }], actions: [{ label: 'Request delisting', priority: 'quick', improvement: '04%' }, { label: 'Fix spam sources', priority: 'high', improvement: '03%' }] }
    //     ],
    //     'Sensitive File & Data Exposures': [
    //         { id: 'files', title: 'Exposed Files', subtitle: "'Sensitive documents'", percent: '-11%', items: [{ count: 15, label: 'Config Files', type: 'teal' }, { count: 8, label: 'Backup Files', type: 'cyan' }], actions: [{ label: 'Remove public access', priority: 'high', improvement: '07%' }, { label: 'Update .htaccess', priority: 'quick', improvement: '04%' }] }
    //     ],
    //     'Code Exposures': [
    //         { id: 'repos', title: 'Code Repos', subtitle: "'Source code leaks'", percent: '-6%', items: [{ count: 3, label: 'Public Repos', type: 'teal' }, { count: 7, label: 'Exposed Secrets', type: 'cyan' }], actions: [{ label: 'Make repos private', priority: 'high', improvement: '04%' }, { label: 'Rotate secrets', priority: 'high', improvement: '02%' }] }
    //     ],
    //     'Email Security Misconfiguration': [
    //         { id: 'spf', title: 'SPF/DKIM/DMARC', subtitle: "'Email authentication'", percent: '-8%', items: [{ count: 1, label: 'Missing SPF', type: 'teal' }, { count: 1, label: 'No DMARC', type: 'cyan' }], actions: [{ label: 'Configure SPF', priority: 'quick', improvement: '04%' }, { label: 'Enable DMARC', priority: 'quick', improvement: '04%' }] }
    //     ],
    //     'Infrastructure Configuration Risk': [
    //         { id: 'infra', title: 'Infra Issues', subtitle: "'Server misconfigs'", percent: '-14%', items: [{ count: 8, label: 'Open Ports', type: 'teal' }, { count: 5, label: 'Weak TLS', type: 'cyan' }], actions: [{ label: 'Close unused ports', priority: 'high', improvement: '08%' }, { label: 'Upgrade TLS', priority: 'quick', improvement: '06%' }] }
    //     ],
    //     'Network Threat': [
    //         { id: 'threats', title: 'Active Threats', subtitle: "'Network attacks'", percent: '-5%', items: [{ count: 2, label: 'DDoS Attempts', type: 'teal' }, { count: 4, label: 'Scan Activity', type: 'cyan' }], actions: [{ label: 'Enable WAF', priority: 'high', improvement: '03%' }, { label: 'Rate limiting', priority: 'quick', improvement: '02%' }] }
    //     ]
    // };

    // const vulnerabilities = vulnerabilitiesData[selectedCategory] || [];
    // const vulnPositions = vulnerabilities.length === 3 ? [55, 220, 385] : vulnerabilities.length === 2 ? [115, 300] : [200];

    // const selectedIndex = categories.findIndex(c => c.name === selectedCategory);
    // const categoryY = 90 + selectedIndex * 50 + 20;

    // const scoreX = 80;
    // const catX = 220;
    // const vulnX = 620;
    // const actionX = 930;
    // const priorityX = 1200;

    // const getFlowPaths = () => {
    //     const boxCenterOffset = 60;
    //     const catEndX = catX + 280;
    //     if (vulnerabilities.length === 3) {
    //         return [
    //             { d: `M ${catEndX} ${categoryY} C ${catEndX + 40} ${categoryY - 30}, ${vulnX - 40} ${vulnPositions[0] + boxCenterOffset}, ${vulnX - 5} ${vulnPositions[0] + boxCenterOffset}`, width: 50, opacity: 0.5, color: "#a8e4df" },
    //             { d: `M ${catEndX} ${categoryY} C ${catEndX + 60} ${categoryY}, ${vulnX - 20} ${vulnPositions[1] + boxCenterOffset}, ${vulnX - 5} ${vulnPositions[1] + boxCenterOffset}`, width: 38, opacity: 0.45, color: "#b8ebe7" },
    //             { d: `M ${catEndX} ${categoryY} C ${catEndX + 40} ${categoryY + 50}, ${vulnX - 40} ${vulnPositions[2] + boxCenterOffset}, ${vulnX - 5} ${vulnPositions[2] + boxCenterOffset}`, width: 26, opacity: 0.4, color: "#c8f0ed" }
    //         ];
    //     } else if (vulnerabilities.length === 2) {
    //         return [
    //             { d: `M ${catEndX} ${categoryY} C ${catEndX + 50} ${categoryY - 20}, ${vulnX - 30} ${vulnPositions[0] + boxCenterOffset}, ${vulnX - 5} ${vulnPositions[0] + boxCenterOffset}`, width: 45, opacity: 0.5, color: "#a8e4df" },
    //             { d: `M ${catEndX} ${categoryY} C ${catEndX + 50} ${categoryY + 40}, ${vulnX - 30} ${vulnPositions[1] + boxCenterOffset}, ${vulnX - 5} ${vulnPositions[1] + boxCenterOffset}`, width: 32, opacity: 0.45, color: "#b8ebe7" }
    //         ];
    //     } else {
    //         return [
    //             { d: `M ${catEndX} ${categoryY} C ${catEndX + 60} ${categoryY}, ${vulnX - 20} ${vulnPositions[0] + boxCenterOffset}, ${vulnX - 5} ${vulnPositions[0] + boxCenterOffset}`, width: 40, opacity: 0.5, color: "#a8e4df" }
    //         ];
    //     }
    // };

    // const flowPaths = getFlowPaths();

    return (
        <>
            <div className="dashboard-main-content">
                {/* <Row>
                    <Col lg={12}>
                        <div className="chart-container">
                            <div className="bg-gray-100 p-4 min-h-screen overflow-x-auto">
                                <svg viewBox="0 0 1500 620" className="w-full min-w-[1400px]">
                                    <g transform={`translate(${scoreX}, 295)`}>
                                        <circle cx="0" cy="0" r="75" fill="white"/>
                                        <circle cx="0" cy="0" r="75" fill="none" stroke="#e8e8e8" strokeWidth="5"/>
                                        <text x="0" y="-18" textAnchor="middle" fill="#9ca3af" fontSize="12">Total Score</text>
                                        <text x="0" y="20" textAnchor="middle" fontSize="48" fontWeight="300" fill="#374151">700</text>
                                        <rect x="-35" y="35" width="70" height="22" rx="11" fill="#fef9c3"/>
                                        <text x="0" y="50" textAnchor="middle" fontSize="10" fill="#b45309" fontWeight="700" letterSpacing="0.5">EXCELLENT</text>
                                    </g>

                                    <path 
                                        d={`M ${scoreX + 60} 295 Q ${scoreX + 100} ${295 + (categoryY - 295) * 0.5}, ${catX} ${categoryY}`}
                                        fill="none" 
                                        stroke="#b5e8e4" 
                                        strokeWidth={20}
                                        strokeLinecap="round" 
                                        opacity={0.5}
                                    />

                                    {flowPaths.map((path, i) => (
                                        <path key={i} d={path.d} fill="none" stroke={path.color} strokeWidth={path.width} strokeLinecap="round" opacity={path.opacity}/>
                                    ))}

                                    <g transform={`translate(${catX}, 90)`}>
                                        {categories.map((cat, i) => {
                                            const isActive = selectedCategory === cat.name;
                                            return (
                                                <g key={i} transform={`translate(0, ${i * 50})`} style={{ cursor: 'pointer' }} onClick={() => setSelectedCategory(cat.name)}>
                                                    {isActive && cat.percent && (
                                                    <>
                                                        <rect x="-50" y="8" width="44" height="24" rx="5" fill="#2dbdb5"/>
                                                        <text x="-28" y="24" textAnchor="middle" fontSize="12" fill="white" fontWeight="500">{cat.percent}</text>
                                                    </>
                                                    )}
                                                    <rect x="0" y="0" width="280" height="40" rx="4" fill={isActive ? '#FFFFFF' : '#F5F5F5'} stroke="#e8e8e8" strokeWidth="1"/>
                                                    {isActive && (
                                                    <rect x="0" y="0" width="2" height="40" fill="#2dbdb5"/>
                                                    )}
                                                    <text x="18" y="25" fontSize="14" fill="#4b5563">{cat.name}</text>
                                                </g>
                                            );
                                        })}
                                    </g>

                                    {vulnerabilities.map((vuln, vIndex) => {
                                        const yPos = vulnPositions[vIndex];
                                        return (
                                            <g key={vuln.id}>
                                                <g transform={`translate(${vulnX}, ${yPos})`}>
                                                    <rect x="-55" y="35" width="40" height="22" rx="4" fill="#2dbdb5"/>
                                                    <text x="-35" y="50" textAnchor="middle" fontSize="12" fill="white" fontWeight="500">{vuln.percent}</text>
                                                    <rect x="0" y="0" width="210" height="120" rx="6" fill="#F5F5F5" stroke="#e8e8e8" strokeWidth="1"/>
                                                    <text x="18" y="30" fontSize={vuln.title.length > 10 ? 18 : 22} fontWeight="600" fill="#0891b2">{vuln.title}</text>
                                                    <text x="18" y="48" fontSize="11" fill="#a1a1aa" fontStyle="italic">{vuln.subtitle}</text>
                                                    {vuln.items.map((item, iIndex) => (
                                                    <g key={iIndex} transform={`translate(18, ${62 + iIndex * 28})`}>
                                                        <rect x="0" y="0" width="28" height="22" rx="4" fill={item.type === 'teal' ? '#2dbdb5' : '#0891b2'}/>
                                                        <text x="14" y="15" textAnchor="middle" fontSize="11" fill="white" fontWeight="600">{item.count}</text>
                                                        <text x="36" y="15" fontSize="12" fill="#4b5563">{item.label}</text>
                                                    </g>
                                                    ))}
                                                </g>

                                                <path d={`M ${vulnX + 210} ${yPos + 73} C ${vulnX + 240} ${yPos + 73}, ${vulnX + 250} ${yPos + 50}, ${actionX} ${yPos + 50}`} stroke="#d4d4d4" strokeWidth="1.5" fill="none"/>
                                                <path d={`M ${vulnX + 210} ${yPos + 101} C ${vulnX + 240} ${yPos + 101}, ${vulnX + 250} ${yPos + 106}, ${actionX} ${yPos + 106}`} stroke="#d4d4d4" strokeWidth="1.5" fill="none"/>

                                                <g transform={`translate(${actionX}, ${yPos + 30})`}>
                                                    {vuln.actions.map((action, aIndex) => (
                                                    <g key={aIndex} transform={`translate(0, ${aIndex * 56})`}>
                                                        <rect x="0" y="0" width="170" height="40" rx="6" fill="white"/>
                                                        <circle cx="20" cy="20" r="14" fill="#0891b2"/>
                                                        <path d="M15 20 L24 20 M21 16 L25 20 L21 24" stroke="white" strokeWidth="2" fill="none" strokeLinecap="round"/>
                                                        <text x="44" y="24" fontSize="12" fill="#4b5563">{action.label}</text>
                                                    </g>
                                                    ))}
                                                </g>

                                                <path d={`M ${actionX + 170} ${yPos + 50} L ${priorityX} ${yPos + 50}`} stroke="#d4d4d4" strokeWidth="1.5" fill="none"/>
                                                <path d={`M ${actionX + 170} ${yPos + 106} L ${priorityX} ${yPos + 106}`} stroke="#d4d4d4" strokeWidth="1.5" fill="none"/>

                                                <g transform={`translate(${priorityX}, ${yPos + 30})`}>
                                                    {vuln.actions.map((action, aIndex) => (
                                                    <g key={aIndex} transform={`translate(0, ${aIndex * 56})`}>
                                                        <g transform="translate(14, 20)">
                                                        <rect x="-10" y="-10" width="20" height="20" rx="3" fill={action.priority === 'quick' ? '#fef9c3' : '#fee2e2'} stroke={action.priority === 'quick' ? '#fde68a' : '#fecaca'} strokeWidth="1" transform="rotate(45)"/>
                                                        {action.priority === 'high' && (
                                                            <path d="M-5 0 L5 0 M0 -5 L0 5" stroke="#f87171" strokeWidth="2.5" strokeLinecap="round"/>
                                                        )}
                                                        </g>
                                                        <text x="38" y="24" fontSize="12" fill="#4b5563">{action.priority === 'quick' ? 'Quick Win' : 'High Priority'}</text>
                                                        <text x="125" y="24" fontSize="13" fill="#10b981">↑</text>
                                                        <text x="138" y="24" fontSize="12" fill="#4b5563">{action.improvement}</text>
                                                    </g>
                                                    ))}
                                                </g>
                                            </g>
                                        );
                                    })}
                                </svg>
                            </div>
                        </div>
                    </Col>
                </Row> */}
                <Row>
                    <Col lg={4}>
                        {
                            isDigitalAssetLoading ?
                            <SkeletonLoader type={"line"} count={5}/>
                            :
                            <motion.div
                                className="h-100"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.4 }}
                            >
                                <div className="bg-white-with-shadow digital-assets p-4 h-100">
                                    <div className="dashboard-type-container dashboard-bg rounded">
                                        <div className="header-content d-flex justify-content-between dashboard-box-container">
                                            <p className="heading">Digital Assets</p>
                                            {/* <p className="view-all"><img src={move} alt="search" className="position-absolute search-icon" /></p> */}
                                        </div>
                                        <div className="total-records-container">
                                            <p className="content">{formatNumber(totalDigitalAsset)} <span>Total </span></p>
                                        </div>
                                    </div>                            
                                    <div className="dashboard-type-container rounded p-3 mt-4">
                                        <div className="header-content d-flex justify-content-between align-items-center">
                                            <p className="heading">Subdomains</p>
                                            <p className="view-all">{formatNumber(digitalAssetResponse?.stats?.digital_asset?.subdomain)}</p>
                                        </div>
                                    </div>
                                    <div className="dashboard-type-container rounded p-3 mt-2">
                                        <div className="header-content d-flex justify-content-between align-items-center">
                                            <p className="heading">IP Address</p>
                                            <p className="view-all">{formatNumber(digitalAssetResponse?.stats?.digital_asset?.ip_address)}</p>
                                        </div>
                                    </div>
                                </div>
                            </motion.div>
                            
                        }
                    </Col>
                    <Col lg={8}>
                        {
                            isDigitalFootPrintLoading ?
                            <SkeletonLoader type={"line"} count={5}/>                            
                            :
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.4 }}
                            >
                                <div className="bg-white-with-shadow digital-footprint p-4 h-100">
                                    <div className="dashboard-type-container dashboard-bg rounded">
                                        <div className="header-content d-flex justify-content-between dashboard-box-container">
                                            <p className="heading">Digital Footprint</p>
                                            {/* <p className="view-all"><img src={move} alt="search" className="position-absolute search-icon" /></p> */}
                                        </div>
                                        <div className="total-records-container">
                                            <p className="content">{totalDigitalFootPrint} <span>Total </span></p>
                                        </div>
                                    </div>
                                    <Row>
                                        <Col lg={4}>
                                            <div className="dashboard-type-container rounded p-3 mt-4">
                                                <div className="header-content d-flex justify-content-between align-items-center">
                                                    <p className="heading">Open Ports</p>
                                                    <p className="view-all">{formatNumber(digitalFootPrintResponse?.stats?.digital_footprint?.open_port)}</p>
                                                </div>
                                            </div>
                                            <div className="dashboard-type-container rounded p-3 mt-2">
                                                <div className="header-content d-flex justify-content-between align-items-center">
                                                    <p className="heading">Git Leaks</p>
                                                    <p className="view-all">{formatNumber(digitalFootPrintResponse?.stats?.digital_footprint?.gitleak)}</p>
                                                </div>
                                            </div>
                                            <div className="dashboard-type-container rounded p-3 mt-2">
                                                <div className="header-content d-flex justify-content-between align-items-center">
                                                    <p className="heading">Associated Domains</p>
                                                    <p className="view-all">{formatNumber(digitalFootPrintResponse?.stats?.digital_footprint?.associated_domain)}</p>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg={4}>
                                            <div className="dashboard-type-container rounded p-3 mt-4">
                                                <div className="header-content d-flex justify-content-between align-items-center">
                                                    <p className="heading">SSL Certificates</p>
                                                    <p className="view-all">{formatNumber(digitalFootPrintResponse?.stats?.digital_footprint?.ssl_certificate)}</p>
                                                </div>
                                            </div>
                                            <div className="dashboard-type-container rounded p-3 mt-2">
                                                <div className="header-content d-flex justify-content-between align-items-center">
                                                    <p className="heading">DNS Records</p>
                                                    <p className="view-all">{formatNumber(digitalFootPrintResponse?.stats?.digital_footprint?.dns_record)}</p>
                                                </div>
                                            </div>
                                            <div className="dashboard-type-container rounded p-3 mt-2">
                                                <div className="header-content d-flex justify-content-between align-items-center">
                                                    <p className="heading">Hosting Providers</p>
                                                    <p className="view-all">{formatNumber(digitalFootPrintResponse?.stats?.digital_footprint?.hosting_provider)}</p>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg={4}>
                                            <div className="dashboard-type-container rounded p-3 mt-4">
                                                <div className="header-content d-flex justify-content-between align-items-center">
                                                    <p className="heading">Technologies</p>
                                                    <p className="view-all">{formatNumber(digitalFootPrintResponse?.stats?.digital_footprint?.technology)}</p>
                                                </div>
                                            </div>
                                            <div className="dashboard-type-container rounded p-3 mt-2">
                                                <div className="header-content d-flex justify-content-between align-items-center">
                                                    <p className="heading">Web Servers</p>
                                                    <p className="view-all">{formatNumber(digitalFootPrintResponse?.stats?.digital_footprint?.webserver)}</p>
                                                </div>
                                            </div>
                                            <div className="dashboard-type-container rounded p-3 mt-2">
                                                <div className="header-content d-flex justify-content-between align-items-center">
                                                    <p className="heading">Mobile Apps</p>
                                                    <p className="view-all">{formatNumber(digitalFootPrintResponse?.stats?.digital_footprint?.mobile_application)}</p>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </motion.div>
                        }
                    </Col>
                </Row>

                <Findings />
                <BrandInsights />
                {organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" && <OrganizationHacker />}
                {domainId.toLowerCase() !== "all" && <DomainRiskScore />}
                {domainId.toLowerCase() !== "all" && <DomainHackerScore domainId={domainId} scanId={scanId} organizationId={organizationId}/>}
                <BubbleChart />
                <TopVulnerabilities />
                <MapChart />
                <TopSubDomains />
                {domainId.toLowerCase() !== "all" && <BusinessEmail />} 
            </div>
        </>
    )
}


export default Dashboard;
